/* eslint-disable prefer-destructuring */
import { DateTime } from "luxon";
import currency from "./Currency";

export function capitalize(str = "") {
  let newStr = [];
  if (str.includes("-")) newStr = str.split("-");
  else if (str.includes("_")) newStr = str.split("_");
  else newStr = str.split(" ");
  return newStr
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}

export function defaultDateFormat(date) {
  try {
    if (!date) return "";
    let nDate = date;
    if (typeof nDate === "string") {
      nDate = String(nDate).split("T")[0];
    }
    if (DateTime.fromFormat(nDate, "yyyy-MM-dd").isValid) {
      return DateTime.fromISO(nDate, { zone: "utc" }).toFormat("MM/dd/yyyy");
    }
    return capitalize(date);
  } catch (err) {
    return "";
  }
}

const sanitizeCurrency = (number) => {
  try {
    const text = String(number);
    const result = text?.replace(/\.$/, "");
    return new Intl.NumberFormat().format(
      Number.parseFloat(result.replace(/[^0-9.]/g, ""))
    );
  } catch (e) {
    return number;
  }
};

export const typeCast = (value, type) => {
  switch (type) {
    case "date": {
      const formatedVal = defaultDateFormat(value);
      return formatedVal;
    }
    case "currency": {
      const formatedVal = sanitizeCurrency(value);
      return formatedVal;
    }
    default: {
      return value;
    }
  }
};

export function dateFormat(date) {
  if (!date) return null;
  return DateTime.fromISO(date, { zone: "utc" })
    .toLocal()
    .toFormat("dd MMM yyyy t");
}

export const getFormatPhoneUS = (phoneNumberString) => {
  const cleaned = `${phoneNumberString}`.replace(/\D/g, "");
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? "+1 " : "";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return phoneNumberString;
};
export function capitalizeEachLetter(str = "") {
  if (!str) return str;
  const newStr = str.split(" ");
  return newStr
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}

export const toSentenceCase = (inputString) => {
  // Split the input string into words
  const words = inputString.split(" ");

  // Capitalize the first letter of each word
  const sentenceCaseWords = words.map((word) => {
    if (word.length === 0) {
      return word; // Handle empty strings gracefully
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

  // Join the words back together to form the sentence
  const sentenceCaseString = sentenceCaseWords.join(" ");

  return sentenceCaseString;
};

export const roundUpCurrency = (value) => {
  return currency(value, { precision: 0 }).format();
};

export const formatCurrencyOrPercent = (
  value,
  symbol = "",
  roundUp = false,
  precision = 2
) => {
  if (roundUp && symbol)
    return currency(value, { symbol, separator: ",", precision: 0 }).format();
  if (roundUp)
    return currency(value, { separator: ",", precision: 0 }).format();
  if (symbol)
    return currency(value, { symbol, separator: ",", precision: 2 }).format();
  return currency(value, { separator: ",", precision }).value;
};

export const formatDateWithOtherDetails = (inputString, type) => {
  const dateRegex = /(\d{4}-\d{2}-\d{2})/;
  const dateMatch = inputString?.match(dateRegex);
  if (dateMatch) {
    const parsedDate = DateTime.fromISO(dateMatch[0]);
    if (parsedDate.isValid) {
      const formattedDate = parsedDate.toFormat("LL/dd/yyyy");
      const formattedString = inputString.replace(dateRegex, formattedDate);
      return formattedString;
    }
    return "Invalid date";
  }
  if (type === "currency") {
    return formatCurrencyOrPercent(inputString, "", true);
  }
  if (type === "percent") {
    return formatCurrencyOrPercent(inputString, " ", false, 2);
  }
  return inputString;
};

export function toCamelCase(str) {
  return str
    .toLowerCase() // Convert the entire string to lowercase
    .split(' ')    // Split the string by spaces
    .map((word, index) => 
      index === 0 
        ? word 
        : word.charAt(0).toUpperCase() + word.slice(1)
    )              // Capitalize the first letter of each word except the first one
    .join('');     // Join the words back together
}